export function toSafeMessage(value, fallback = "Bir hata oluştu") {
  if (typeof value === "string") {
    const text = value.trim();
    return text || fallback;
  }

  if (value == null) return fallback;

  if (value instanceof Error) {
    return toSafeMessage(value.message, fallback);
  }

  if (Array.isArray(value)) {
    const joined = value.map((x) => toSafeMessage(x, "")).filter(Boolean).join("\n");
    return joined || fallback;
  }

  if (typeof value === "object") {
    if (typeof value.message === "string" && value.message.trim()) {
      return value.message.trim();
    }
    try {
      return JSON.stringify(value);
    } catch {
      return fallback;
    }
  }

  return String(value);
}

